/**
 * Insurance Agencies Routes
 */
/* eslint-disable */
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

// async components
import {
  AsyncAddLeadSourceComponent,
  AsyncManageLeadSourcesComponent,
  AsyncModifyLeadSourceComponent,
} from "../../components/AsyncComponent/AsyncComponent";

const Forms = ({ match }) => (
  <React.Fragment>
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/manage`} />
      <Route
        path={`${match.url}/view-all`}
        component={AsyncManageLeadSourcesComponent}
      />
      <Route
        path={`${match.url}/create`}
        component={AsyncAddLeadSourceComponent}
      />
      <Route
        path={`${match.url}/modify`}
        component={AsyncModifyLeadSourceComponent}
      />
    </Switch>
  </React.Fragment>
);

export default Forms;
